// LineChart.js
import { HorizontalBar } from 'vue-chartjs'

export default {
  extends: HorizontalBar,
  props: ['data', 'options'],
  mounted () {
    this.renderChart(this.data, this.buildOptions())
  },
  methods: {
    buildOptions() {
      let values = this.data.datasets[0].data
      let dataLength = values.length
      let builtOptions = {
        scales: {
          xAxes: [{
            ticks: {
              suggestedMin: Math.min(values[dataLength-1] - 5, -75),
              suggestedMax: Math.max(values[0] + 5, 75)
            }
          }]
        },
        plugins: {
					datalabels: {
            anchor: function(context) {
              var index = context.dataIndex;
              var value = context.dataset.data[index];
              return value > 0 ? 'start' : 'end';
            },
            align: function(context) {
              var index = context.dataIndex;
              var value = context.dataset.data[index];
              return value > 0 ? 'start' : 'end';
            },
            formatter: (value) => {
              return value + ' %';
            }
          }
				},
      }
      this.$lodash.merge(builtOptions, this.options)
      return builtOptions;
    }
  },
  watch: {
    data: function() {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
      this.renderChart(this.data, this.buildOptions())
    }
  }
}
